export function Distinct(data: any[]) {
    let s: any = JSON.stringify;
    let p: any = JSON.parse;
    return Array.from(new Set(data.map(s))).map(p);
}


// WEBPACK FOOTER //
// ./src/utils/distinct-array.ts